import { MetaHead } from 'components/MetaHead/MetaHead';
import { HeaderWithOptions } from 'components/Header';
import { ContentfulHeroSection } from 'components/ContentfulContent/ContentfulHeroSection';
import { ContentfulBodySection } from 'components/ContentfulContent/ContentfulBodySection';
import { Footer } from 'components/Footer';

import { getPageBySlug } from 'lib/contentful/contentfulClient';
import { withOptimizelyProps } from 'lib/optimizely';

import type { GetServerSidePropsResult } from 'next';
import type { IPage, IPageFields } from 'types/generated/contentful';

interface PageProps {
  page: IPage;
}

export default function LandingPage(props: PageProps) {
  const { page } = props;

  const pageFields = page.fields as IPageFields;
  const {
    title,
    metaDescription,
    metaKeywords,
    headerStyle,
    follow,
    index,
    heroContent,
    bodyContent,
  } = pageFields;
  const showHeaderLinks = headerStyle === 'Full' ? true : false;

  return (
    <>
      <MetaHead
        index={index}
        follow={follow}
        title={title}
        description={metaDescription}
        keywords={metaKeywords?.join(', ')}
      />

      <HeaderWithOptions
        hasLoginLink={false}
        hasNavigationMenu={showHeaderLinks}
        hasPhoneBox={false}
      />

      <ContentfulHeroSection content={heroContent} />
      <ContentfulBodySection content={bodyContent} />

      <Footer />
    </>
  );
}

export const getServerSideProps = withOptimizelyProps<PageProps>(
  async (props): Promise<GetServerSidePropsResult<PageProps>> => {
    // Note: only 1 part slugs are supported now
    // if we also need /lp/banken/vergleich/somethingelse, we need to change this
    // to support an array of slug parts
    const currentSlug = props.params!.slug![0];

    // we need to fill in the slug part, we cut out in the getServerSidePaths function
    const options = { preview: false, applyStripSys: true };
    const page = (await getPageBySlug(`lp/${currentSlug}`, options)) || null;

    if (!page) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        page,
      },
    };
  },
);
